import { useState, useRef, MutableRefObject } from 'react';

import { TotalMateriaConnector, MaterialOpenedMessage, MaterialClosedMessage, MaterialFileExportMessage, File } from '../connector/TotalMateria';
import { usePostMessageConnector } from './usePostMessageConnector';
import { useAssignment } from './useAssignment';
import Config from '../utils/config';

export function useTMConnector(): { connector: MutableRefObject<TotalMateriaConnector | null>, mtlFile?: File } {
    const assignment = useAssignment();
    const [file, setFile] = useState<File | undefined>(undefined);

    function handleMaterialOpened(m: MaterialOpenedMessage): void {
        // Always clear adb on portal-opened events; adb is resolved server-side per material.
        assignment.applyTMMaterial({ id: m.material.id, name: m.material.name, density: '', adb: undefined });
    }

    function handleMaterialClosed(_m: MaterialClosedMessage): void {
        assignment.applyTMMaterial({ id: '', name: '' });
    }

    function handleMaterialFileExport(m: MaterialFileExportMessage): void {
        setFile(m.file);
    }

    const connector = usePostMessageConnector({
        factory: () => new TotalMateriaConnector(),
        initOptions: {
            targetOrigin: Config.get('tmportalOrigin'),
            allowedOrigins: [Config.get('tmportalOrigin'), window.location.origin],
        },
        requiredMessageTypes: [
            { type: MaterialOpenedMessage.type, version: MaterialOpenedMessage.version },
        ],
        onHandshakeComplete: (c) => {
            c.onMessage(MaterialOpenedMessage.type, (m) => handleMaterialOpened(m as MaterialOpenedMessage));
            c.onMessage(MaterialClosedMessage.type, (m) => handleMaterialClosed(m as MaterialClosedMessage));
            c.onMessage(MaterialFileExportMessage.type, (m) => handleMaterialFileExport(m as MaterialFileExportMessage));
        },
    });

    return { connector, mtlFile: file };
}
